export function obterListaCteTipoEmissao() {
  return (
    [
      { label: '1 - Sem Contingência', value: 'NORMAL' },
      { label: '3 - Regime Especial NFF', value: 'NFF' },
      { label: '4 - EPEC', value: 'EPEC pela SVC' },
      { label: '5 - Contingência FSDA', value: 'FSDA' },
      { label: '7 - Contingência  SVC - RS', value: 'SVCRS' },
      { label: '8 - Contingência  SVC - SP', value: 'SVCSP' },
    ]
  );
}
